<template>
<div>
    <page-header title="Perks"></page-header>
    <div class="container">
        <content-loader v-if="$apollo.loading" title="perks" />
        <div class="row" v-else>
            <a class="col-md-6" v-for="perk in filteredPerks" :key="perk.id" v-router-link="{ name: 'PerkDetail', params: { id: perk.id }}">
                <perks-card :perk="perk" />
            </a>
        </div>
    </div>
</div>
</template>

<script>
import ListPerks from '@/gql/ListPerks.gql';
import PerksCard from '@/components/perks/PerksCard';
import PageHeader from '@/components/global/PageHeader';
import ContentLoader from '@/components/global/ContentLoader';
import SearchBar from '@/components/global/SearchBar';

export default {
    name: 'perk-list',

    components: {
        PerksCard,
        PageHeader,
        ContentLoader,
        SearchBar
    },

    data() {
        return {
            query: ""
        }
    },

    computed: {

        filteredPerks() {
            return this.perks && this.perks.filter((perk) => {
                // + perk.tag.toLowerCase().includes(this.query.toLowerCase()))
                // Tags is now an array
                //return (perk.name.toLowerCase().includes(this.query.toLowerCase()) + perk.description.toLowerCase().includes(this.query.toLowerCase());
                return true;
            })
        },
    },
    apollo: {
        perks: ListPerks
    },
}
</script>

<style scoped>

</style>
